module.exports = __webpack_public_path__ + "static/img/Terminus-Hotel.87483ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Terminus-Hotel.jpg
// module id = tvMA
// module chunks = 0